module.exports = require('@emotion/core');
